<div class="text-box" *ngIf="lines?.length">
  <p *ngFor="let text of lines">{{ text }}</p>
</div>
